import { movieData } from "./reducer/reducer";
import { combineReducers } from "redux";

export const rootReducer = combineReducers({ movieData });
